var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgrammingArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "programming-arrows"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/programming-arrows"
  }, /*#__PURE__*/React.createElement("g", {
    id: "programming-arrows_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6667 10.6667V4.33333C12.6667 3.6 12.0667 3 11.3334 3H7.66669",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.33331 1.33331L7.33331 2.99998L9.33331 4.66665",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.6667 14.6667C13.7713 14.6667 14.6667 13.7713 14.6667 12.6667C14.6667 11.5621 13.7713 10.6667 12.6667 10.6667C11.5621 10.6667 10.6667 11.5621 10.6667 12.6667C10.6667 13.7713 11.5621 14.6667 12.6667 14.6667Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.33331 5.33331V11.6666C3.33331 12.4 3.93331 13 4.66665 13H8.33331",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M6.66669 14.6666L8.66669 13L6.66669 11.3333",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.33331 5.33331C4.43788 5.33331 5.33331 4.43788 5.33331 3.33331C5.33331 2.22874 4.43788 1.33331 3.33331 1.33331C2.22874 1.33331 1.33331 2.22874 1.33331 3.33331C1.33331 4.43788 2.22874 5.33331 3.33331 5.33331Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrammingArrows);
export default __webpack_public_path__ + "static/media/programming-arrows.98b9e18b5d96f25a932e918e683c2d3d.svg";
export { ForwardRef as ReactComponent };